interface LoadingDotsProps {
  text?: string;
}

export default function LoadingDots({ text }: LoadingDotsProps) {
  return (
    <>
      <div className="d-flex flex-column align-items-center py-3">
        <div className="d-flex gap-2 align-items-center">
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: "black",
              display: "inline-block",
              animation: "pulse 1.4s ease-in-out infinite",
            }}
          />
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: "black",
              display: "inline-block",
              animation: "pulse 1.4s ease-in-out 0.2s infinite",
            }}
          />
          <span
            style={{
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: "black",
              display: "inline-block",
              animation: "pulse 1.4s ease-in-out 0.4s infinite",
            }}
          />
        </div>
        {text && <p className="text-muted mt-2 mb-0">{text}</p>}
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.3;
          }
        }
      `}</style>
    </>
  );
}

